import { Box, Paper, Tab, Tabs, styled } from '@mui/material'

interface WarningMessageContainerProps {
  activeTab: number
  showFullWarning: boolean
}

export const PropertyContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: 'none',
  overflow: 'hidden',
}))

export const PropertyHeader = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[50],
  height: '54px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
}))

export const PropertyTabs = styled(Tabs)(() => ({
  height: 54,

  '& .MuiTabs-indicator': {
    height: 2,
  },
}))

export const PropertyTab = styled(Tab)(({ theme }) => ({
  minHeight: 36,
  height: 54,
  padding: theme.spacing(0.5, 1.5),
  fontSize: 14,
  fontWeight: 700,
  textTransform: 'uppercase',
  color: theme.palette.text.primary,
  opacity: 1,
  visibility: 'visible',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& .MuiTab-wrapper': {
    color: theme.palette.text.primary,
    opacity: 1,
    visibility: 'visible',
  },

  '&.Mui-selected': {
    color: theme.palette.primary.main,
    opacity: 1,

    '& .MuiTab-wrapper': {
      color: theme.palette.primary.main,
      opacity: 1,
    },
  },
}))

export const PropertyContent = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(2),
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  maxHeight: '700px',
}))

export const ContentPlaceholder = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '14px',
  margin: 'auto',
}))

export const WarningMessageContainer = styled(Box)<WarningMessageContainerProps>(({ activeTab, showFullWarning }) => ({
  textAlign: 'justify',
  ...(activeTab === 0 &&
    !showFullWarning && {
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    }),
}))
